module.exports = __webpack_public_path__ + "static/media/frost-setting-cake-pops.862ffb8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2020-06-06/frost-setting-cake-pops.jpg
// module id = 827
// module chunks = 0